import {
    FIRST_OR_NIL,
    IF,
    IS,
    IS_NOT,
    nil,
    NO,
    RETURNER,
    UIButton,
    UIRectangle,
    UITextView,
    UIView,
    YES
} from "uicore-ts"
import { RHButton } from "../RH/RHButton"
import { RHButtons, RHDialogs } from "../RH/Utils_slop/RHDesignTokens"
import { RowView } from "../RowView"


export class CBDialogView<ViewType extends UIView = UIView> extends UIView {
    
    titleLabel: UITextView = nil
    titleRow: RowView = nil
    placeholderLabel: UITextView = nil
    
    _view: ViewType = nil
    
    questionLabel: UITextView = nil
    yesButton: RHButton = nil
    noButton: RHButton = nil
    cancelButton: RHButton = nil
    closeButton: RHButton = nil
    isMessageDialog = NO
    isQuestionDialog = NO
    isQuestionWithSupportingText = NO
    
    noButtonDismissesDialog = YES
    
    constructor(elementID?: string) {
    
        super(elementID)
    
        this.backgroundColor = RHDialogs.dialogSurfaceBackgroundColor
        this.style.borderRadius = RHDialogs.dialogSurfaceBorderRadius
        this.style.boxShadow = RHDialogs.dialogSurfaceBoxShadow
    
        this.updateContent()
    
    }
    
    
    set view(view: ViewType) {
        this.view.removeFromSuperview()
        this._view = view
        this.addSubview(view)
    }
    
    get view() {
        return this._view
    }
    
    
    initCancelButtonIfNeeded() {
        
        if (IS_NOT(this.cancelButton)) {
            
            this.cancelButton = new RHButton(this.elementID + "CancelButton")
            this.cancelButton.configureWithObject({
                titleLabel: { text: RHDialogs.confirmationAlertButtonTitle },
                variant: RHDialogs.confirmationAlertButtonVariant,
                contentPadding: RHDialogs.confirmationAlertButtonContentPadding,
                style: {
                    fontSize: RHDialogs.confirmationAlertButtonFontSize
                }
            })
            this.addSubview(this.cancelButton)
            
            this.cancelButton.addTargetForControlEvents([
                UIButton.controlEvent.PointerUpInside, UIButton.controlEvent.EnterDown
            ], function (this: CBDialogView, sender: UIButton, event: Event) {
                this.dialogView?.dismiss()
            }.bind(this))
            
        }
        
    }
    
    initYesNoButtonsIfNeeded() {
        
        if (IS_NOT(this.yesButton)) {
            
            this.yesButton = new RHButton(this.elementID + "YesButton")
            this.yesButton.configureWithObject({
                titleLabel: { text: RHDialogs.confirmationYesButtonTitle },
                variant: RHDialogs.confirmationYesButtonVariant,
                contentPadding: RHDialogs.confirmationButtonContentPadding,
                style: {
                    fontSize: RHDialogs.confirmationButtonFontSize
                }
            })
            this.addSubview(this.yesButton)
            
            this.noButton = new RHButton(this.elementID + "NoButton")
            this.noButton.configureWithObject({
                titleLabel: { text: RHDialogs.confirmationNoButtonTitle },
                variant: RHDialogs.confirmationNoButtonVariant,
                contentPadding: RHDialogs.confirmationButtonContentPadding,
                style: {
                    fontSize: RHDialogs.confirmationButtonFontSize
                }
            })
            this.addSubview(this.noButton)
            
            // this.yesButton.addTargetForControlEvents([UIButton.controlEvent.PointerUpInside, UIButton.controlEvent.EnterDown], function (this: CBDialogView, sender: UIButton, event: Event) {
            //     this.dialogView.dismiss()
            // }.bind(this))
            
            this.noButton.addTargetForControlEvents([
                UIButton.controlEvent.PointerUpInside, UIButton.controlEvent.EnterDown
            ], function (this: CBDialogView, sender: UIButton, event: Event) {
                if (this.noButtonDismissesDialog) {
                    this.dialogView?.dismiss()
                }
            }.bind(this))
            
        }
        
        
    }

    initCloseButtonIfNeeded() {

        if (IS_NOT(this.closeButton)) {

            this.closeButton = new RHButton(this.elementID + "CloseButton")
            this.closeButton.configureWithObject({
                titleLabel: {
                    text: RHButtons.dialogCloseTitle,
                    style: {
                        fontSize: RHButtons.dialogCloseFontSize,
                        lineHeight: RHButtons.dialogCloseLineHeight
                    }
                },
                variant: RHButtons.dialogCloseVariant,
                contentPadding: RHButtons.dialogCloseContentPadding,
                style: {
                    padding: RHButtons.dialogClosePadding,
                    borderRadius: RHButtons.dialogCloseBorderRadius
                }
            })
            this.addSubview(this.closeButton)

            this.closeButton.controlEventTargetAccumulator.PrimaryActionTriggered = () => {
                this.dialogView?.dismiss()
            }

        }

    }
    
    initQuestionLabelIfNeeded() {
        
        if (IS_NOT(this.questionLabel)) {
            
            this.questionLabel = new UITextView(this.elementID + "QuestionLabel", UITextView.type.paragraph)
            this.questionLabel.text = RHDialogs.confirmationQuestionTitle
            this.questionLabel.isSingleLine = NO
            this.questionLabel.textColor = RHDialogs.confirmationQuestionTextColor
            this.questionLabel.textAlignment = UITextView.textAlignment.center
            this.questionLabel.style.fontSize = RHDialogs.confirmationQuestionFontSize
            this.questionLabel.style.fontWeight = RHDialogs.confirmationQuestionFontWeight
            this.questionLabel.style.lineHeight = RHDialogs.confirmationQuestionLineHeight
            this.questionLabel.style.whiteSpace = "normal"
            this.questionLabel.style.overflowWrap = "break-word"
            this.questionLabel.style.wordBreak = "normal"
            this.questionLabel.style.overflow = "visible"
            this.questionLabel.style.textOverflow = "clip"
            this.questionLabel.textElementView.style.whiteSpace = "normal"
            this.questionLabel.textElementView.style.overflowWrap = "break-word"
            this.questionLabel.textElementView.style.wordBreak = "normal"
            this.questionLabel.textElementView.style.overflow = "visible"
            this.questionLabel.textElementView.style.textOverflow = "clip"
            this.addSubview(this.questionLabel)
            
        }
        
    }
    
    initTitleRow() {
        
        if (IS_NOT(this.titleRow)) {
            
            this.titleRow = new RowView(this.elementID + "TitleRow")
            this.addSubview(this.titleRow)
            
        }
        
    }
    
    initTitleLabelIfNeeded() {
        
        if (IS_NOT(this.titleLabel)) {
            
            this.titleLabel = new UITextView(this.elementID + "TitleLabel", UITextView.type.paragraph)
            this.titleLabel.text = "Accept offer"
            this.titleLabel.isSingleLine = NO
            this.titleLabel.textColor = RHDialogs.confirmationTitleTextColor
            this.titleLabel.style.fontSize = RHDialogs.confirmationTitleFontSize
            this.titleLabel.style.fontWeight = RHDialogs.confirmationTitleFontWeight
            this.titleLabel.style.lineHeight = RHDialogs.confirmationTitleLineHeight
            this.addSubview(this.titleLabel)
            
        }
        
    }

    configureForMessageDialog() {

        this.isMessageDialog = YES
        this.initTitleLabelIfNeeded()
        this.titleLabel.textColor = RHDialogs.confirmationAlertTextColor
        this.titleLabel.textAlignment = RHDialogs.confirmationAlertTextAlignment
        this.titleLabel.style.fontSize = RHDialogs.confirmationAlertTextFontSize
        this.titleLabel.style.fontWeight = RHDialogs.confirmationAlertTextFontWeight
        this.titleLabel.style.lineHeight = RHDialogs.confirmationAlertTextLineHeight

    }

    configureForQuestionDialog() {

        this.isQuestionDialog = YES
        this.isQuestionWithSupportingText = NO
        this.initTitleLabelIfNeeded()
        this.initQuestionLabelIfNeeded()

        this.titleLabel.configureWithObject({
            textColor: RHDialogs.confirmationQuestionHeadingTextColor,
            textAlignment: RHDialogs.confirmationQuestionHeadingTextAlignment,
            style: {
                fontSize: RHDialogs.confirmationQuestionHeadingFontSize,
                fontWeight: RHDialogs.confirmationQuestionHeadingFontWeight,
                lineHeight: RHDialogs.confirmationQuestionHeadingLineHeight
            }
        })
        this.questionLabel.configureWithObject({
            textColor: RHDialogs.confirmationQuestionHeadingTextColor,
            textAlignment: RHDialogs.confirmationQuestionHeadingTextAlignment,
            style: {
                fontSize: RHDialogs.confirmationQuestionHeadingFontSize,
                fontWeight: RHDialogs.confirmationQuestionHeadingFontWeight,
                lineHeight: RHDialogs.confirmationQuestionHeadingLineHeight
            }
        })

    }

    configureForQuestionWithSupportingText() {

        this.configureForQuestionDialog()
        this.isQuestionWithSupportingText = YES
        this.questionLabel.configureWithObject({
            textColor: RHDialogs.confirmationQuestionSupportingTextColor,
            textAlignment: RHDialogs.confirmationQuestionSupportingTextAlignment,
            style: {
                fontSize: RHDialogs.confirmationQuestionSupportingTextFontSize,
                fontWeight: RHDialogs.confirmationQuestionSupportingTextFontWeight,
                lineHeight: RHDialogs.confirmationQuestionSupportingTextLineHeight
            }
        })

    }
    
    initPlaceholderLabelIfNeeded() {
        
        if (IS_NOT(this.placeholderLabel)) {
            
            this.placeholderLabel = new UITextView(this.elementID + "PlaceholderLabel", UITextView.type.header4)
            this.placeholderLabel.text = "No offers have been made yet."
            this.addSubview(this.placeholderLabel)
            
        }
        
    }
    
    updateContent() {
    
        this.layoutSubviews()
        
    }
    
    
    override layoutSubviews() {
    
        super.layoutSubviews()
    
        const padding = this.core.paddingLength
        let bounds = this.bounds.rectangleWithInsets(padding * 0.5, padding * 0.5, 0, 0)

        if (this.isMessageDialog) {
            this._layoutMessageDialogSubviews(
                this.contentBoundsWithInset(RHDialogs.confirmationDialogContentInset)
            )
            return
        }

        if (this.isQuestionDialog) {
            bounds = this.contentBoundsWithInset(RHDialogs.confirmationDialogContentInset)
        }

        let questionTextBounds = bounds
        if (this.isQuestionDialog && IS(this.closeButton)) {
            this.closeButton.frame = bounds
                .rectangleWithHeight(RHDialogs.confirmationCloseButtonSize)
                .rectangleWithWidth(RHDialogs.confirmationCloseButtonSize, 1)
            const questionTextSideInset =
                RHDialogs.confirmationCloseButtonSize +
                RHDialogs.confirmationCloseButtonTextGap
            questionTextBounds = bounds.rectangleWithInsets(
                questionTextSideInset,
                questionTextSideInset,
                0,
                0
            )
        }
    
        const topObject = { frame: bounds.rectangleWithHeight(0) }

        let titleLabelBounds = questionTextBounds
        if (!this.isQuestionDialog) {
            titleLabelBounds = titleLabelBounds.rectangleWithInsets(padding * 0.5, 0, 0, 0)
        }

        let titleLabelY = bounds.y + padding * 0.5
        if (this.isQuestionDialog) {
            titleLabelY = bounds.y
        }

        this.titleLabel.frame = titleLabelBounds
            .rectangleWithHeight(this.titleLabel.intrinsicContentHeight(titleLabelBounds.width))
            .rectangleWithY(titleLabelY)
    
        this.titleRow.frame = FIRST_OR_NIL(this.titleLabel, topObject).frame.rectangleForNextRow(
            0,
            this.titleRow.intrinsicContentHeight(bounds.width)
        )
    
    
        this.view.frame = FIRST_OR_NIL(this.titleRow, this.titleLabel, topObject).frame.rectangleForNextRow(
            padding,
            this.view.intrinsicContentHeight(bounds.width)
        ).rectangleWithWidth(bounds.width).rectangleWithX(bounds.x)
        
        
        let questionTopGap: number = RHDialogs.confirmationQuestionTopGap
        if (this.isQuestionDialog) {
            questionTopGap = 0
        }
        if (this.isQuestionWithSupportingText) {
            questionTopGap = RHDialogs.confirmationQuestionHeadingToSupportingTextGap
        }

        this.questionLabel.frame = FIRST_OR_NIL(
            this.view,
            this.titleRow,
            this.titleLabel,
            topObject
        ).frame.rectangleForNextRow(
            questionTopGap,
            this.questionLabel.intrinsicContentHeight(questionTextBounds.width)
        ).rectangleWithWidth(questionTextBounds.width).rectangleWithX(questionTextBounds.x)
    
    
        const buttonsFrame = FIRST_OR_NIL(
            this.questionLabel,
            this.view,
            this.titleRow,
            this.titleLabel,
            topObject
        ).frame.rectangleForNextRow(RHDialogs.confirmationButtonTopGap, RHDialogs.confirmationButtonHeight)

        if (IS(this.yesButton)) {
            const buttons = [this.noButton, this.yesButton]
            const buttonWidth = this._confirmationButtonWidth(buttons)
            buttonsFrame
                .rectangleWithWidth(
                    buttonWidth * 2 + RHDialogs.confirmationButtonGap,
                    0.5
                )
                .distributeViewsAlongWidth(
                    buttons,
                    undefined,
                    RHDialogs.confirmationButtonGap,
                    [buttonWidth, buttonWidth]
                )
        }

        if (IS(this.cancelButton)) {
            this.cancelButton.frame = buttonsFrame.rectangleWithWidth(
                this.cancelButtonWidth(),
                0.5
            )
        }
        
        
        this.placeholderLabel.frame = bounds.rectangleWithInsets(padding * 0.5, padding * 0.5, 0, 0)
        
        
        if (IS(this.view)) {
            
            this.placeholderLabel.hidden = YES
            
            // this.titleLabel.hidden = NO
            // this.titleRow.hidden = NO
            
        }
        else {
            
            
            this.placeholderLabel.hidden = NO
            
            // this.titleLabel.hidden = YES
            // this.titleRow.hidden = YES
            
            
        }
        
        
    }

    private _layoutMessageDialogSubviews(bounds: UIRectangle) {

        let messageHeight = 0
        if (IS(this.view)) {
            messageHeight = this.view.intrinsicContentHeight(bounds.width)
        }
        else {
            messageHeight = this.titleLabel.intrinsicContentHeight(bounds.width)
        }
        const cancelButtonWidth = this.cancelButtonWidth()
        const contentHeight =
            messageHeight +
            RHDialogs.confirmationButtonTopGap +
            RHDialogs.confirmationAlertButtonHeight
        const contentBounds = bounds.rectangleWithHeight(contentHeight, 0.5)

        if (IS(this.view)) {
            this.view.frame = contentBounds.rectangleWithHeight(messageHeight)
        }
        else {
            this.titleLabel.frame = contentBounds.rectangleWithHeight(messageHeight)
        }

        this.cancelButton.frame = contentBounds
            .rectangleWithHeight(messageHeight)
            .rectangleForNextRow(
                RHDialogs.confirmationButtonTopGap,
                RHDialogs.confirmationAlertButtonHeight
            )
            .rectangleWithWidth(cancelButtonWidth, 0.5)

        this.placeholderLabel.frame = bounds.rectangleWithHeight(0)
        this.placeholderLabel.hidden = YES

    }

    private cancelButtonWidth() {

        return IF<number>(this.cancelButton)(() =>
            [
                this.cancelButton.titleLabel.intrinsicContentWidth(RHDialogs.confirmationAlertButtonHeight) +
                RHDialogs.confirmationAlertButtonContentPadding * 2,
                RHDialogs.confirmationAlertButtonWidth
            ].max()
        ).ELSE(() =>
            RHDialogs.confirmationAlertButtonWidth
        )

    }
    
    
    override intrinsicContentHeight(constrainingWidth: number = 0) {
    
    
        const padding = this.core.paddingLength
        if (this.isMessageDialog) {
            const contentWidth = Math.max(
                0,
                constrainingWidth - RHDialogs.confirmationDialogContentInset * 2
            )
            let messageHeight = 0
            if (IS(this.view)) {
                messageHeight = this.view.intrinsicContentHeight(contentWidth)
            }
            else {
                messageHeight = this.titleLabel.intrinsicContentHeight(contentWidth)
            }
            return [
                RHDialogs.confirmationDialogContentInset * 2 +
                messageHeight +
                RHDialogs.confirmationButtonTopGap +
                RHDialogs.confirmationAlertButtonHeight,
                RHDialogs.confirmationAlertDialogMinHeight
            ].max()
        }

        if (this.isQuestionDialog) {
            let contentWidth = Math.max(
                0,
                constrainingWidth - RHDialogs.confirmationDialogContentInset * 2
            )
            if (IS(this.closeButton)) {
                contentWidth = Math.max(
                    0,
                    contentWidth - (
                        RHDialogs.confirmationCloseButtonSize +
                        RHDialogs.confirmationCloseButtonTextGap
                    ) * 2
                )
            }
            let questionTextHeight = this.questionLabel.intrinsicContentHeight(contentWidth)
            if (this.isQuestionWithSupportingText) {
                questionTextHeight =
                    this.titleLabel.intrinsicContentHeight(contentWidth) +
                    RHDialogs.confirmationQuestionHeadingToSupportingTextGap +
                    questionTextHeight
            }
            if (IS(this.view)) {
                questionTextHeight = questionTextHeight +
                    padding +
                    this.view.intrinsicContentHeight(contentWidth)
            }
            return RHDialogs.confirmationDialogContentInset * 2 +
                questionTextHeight +
                RHDialogs.confirmationButtonTopGap +
                RHDialogs.confirmationButtonHeight
        }

        function addPaddingIfNeeded(value: number) {
            
            return IF<number>(value)(function () {
                return value + padding
            })()
            
        }
    
        let result = padding
    
        result = result + addPaddingIfNeeded(this.titleLabel.intrinsicContentHeight(constrainingWidth))
        
        result = result + addPaddingIfNeeded(this.titleRow.intrinsicContentHeight(constrainingWidth))
        
        result = result + addPaddingIfNeeded(this.view.intrinsicContentHeight(constrainingWidth) + padding)
    
        result = result + addPaddingIfNeeded(this.questionLabel.intrinsicContentHeight(constrainingWidth))
    
        result = result + IF<number>(FIRST_OR_NIL(this.yesButton, this.cancelButton))(
            RETURNER(RHDialogs.confirmationButtonTopGap + RHDialogs.confirmationButtonHeight)
        )()
    
    
        return result
    
    }
    
    override intrinsicContentWidth(constrainingHeight?: number): number {
        
        const widths = [super.intrinsicContentWidth(constrainingHeight)]
        
        if (IS(this.yesButton)) {
            const buttonWidth = this._confirmationButtonWidth([this.noButton, this.yesButton])
            widths.push(
                buttonWidth * 2 + RHDialogs.confirmationButtonGap
            )
        }
        
        return widths.max()
        
    }


    _confirmationButtonWidth(buttons: RHButton[]): number {
        return [
            buttons.map(button => button.titleLabel.intrinsicContentWidth()).max()
            + RHDialogs.confirmationButtonContentPadding * 2,
            RHDialogs.confirmationButtonWidth
        ].max()
    }
    
    
}

































